import Immutable from 'seamless-immutable';
import sortBy from 'lodash/sortBy';
import {
  REQUEST_TYPE_DEFAUT,
  RECEIVE_TYPE_DEFAUT,
  FAILURE_TYPE_DEFAUT
} from '../actions/type-defaut.actions';

const INITIAL_STATE = Immutable({
  failure: false,
  fetching: false,
  data: null
});
/*
 * Désactivation de la vérification de l'ordre des paramètres par défaut.
 * Redux impose le premier paramètre (l'état) d'un reducer avec une valeur par défaut, or les paramètres par défaut
 * devraient être positionnés en dernier et non en premier.
 */
/* jshint -W138 */
export default function reduce(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_TYPE_DEFAUT:
      return state.merge({
        fetching: true
      });
    case RECEIVE_TYPE_DEFAUT:
      return state.merge({
        fetching: false,
        data: sortBy(action.payload.data, 'nom')
      });
    case FAILURE_TYPE_DEFAUT:
      return state.merge({
        fetching: false,
        failure: true
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/type-defaut.reducer.js